<template>
    <div>
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col-6">课程与师资信息</div>
                    <div class="col-6 text-right"></div>
                </div>
            </div>
            <div v-if="projectTeacherCourseData.length===0" class="card-body">
                <div class="alert alert-warning mb-0">没有课程与师资信息</div>
            </div>
            <table v-else class="table table-bordered mb-0">
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">序号</th>
                    <th class="text-center align-middle" style="width: 70%">课程</th>
                    <th class="text-center align-middle" style="width: 10%" v-if="showTeacherInfo">讲师</th>
                    <th class="text-center align-middle" style="width: 10%">课时</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in projectTeacherCourseData" :key="item.courseTeacherId">
                    <td class="text-center align-middle">{{index+1}}</td>
                    <td class="text-left align-middle">
                        <a href="#" @click.prevent="btnShowCourseDetailInfo_Click(item.courseId)">{{item.courseName}}</a>
                    </td>
                    <td class="text-center align-middle">
                        <a href="#" @click.prevent="btnShowTrainerDetailInfo_Click(item.personId)">{{item.personName}}</a>
                    </td>
                    <td class="text-center align-middle">{{item.trainLength}}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <b-modal v-model="isShowCourseDetailInfoDialogOpen"
                 title="课程详细信息" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <organ-course-info-view :course-id="currentCourseId"></organ-course-info-view>
        </b-modal>

        <b-modal v-model="isShowTeacherDetailInfoDialogOpen"
                 title="授课讲师详细信息" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <organ-person-basic-info-view :person-id="currentPersonId" :show-detail-info="false"></organ-person-basic-info-view>
            <organ-person-work-info-view :person-id="currentPersonId" class="mt-3"></organ-person-work-info-view>
            <organ-person-description-info-view :person-id="currentPersonId" :person-type="12" class="mt-3"></organ-person-description-info-view>
        </b-modal>
    </div>
</template>

<script>
import projectApi from "@/utils/api/project";
import OrganCourseInfoView from "@/components/user/OrganCourseInfoView";
import OrganPersonBasicInfoView from "@/views/organ/OrganPersonBasicInfoView";
import OrganPersonWorkInfoView from "@/views/organ/OrganPersonWorkInfoView";
import OrganPersonDescriptionInfoView from "@/views/organ/OrganPersonDescriptionInfoView";

export default {
    name: "ProjectTeacherCourseView",
    props: {
        projectId: {type: String, required: true},
        showTeacherInfo: {type: Boolean, required: false, default: true},
        showCourseDetailInfo: {type: Boolean, required: false, default: true},
    },
    components: {
        OrganPersonDescriptionInfoView,
        OrganCourseInfoView,
        OrganPersonBasicInfoView,
        OrganPersonWorkInfoView
    },
    data: function () {
        return {
            projectTeacherCourseData: [],

            currentCourseId: '',
            isShowCourseDetailInfoDialogOpen: false,

            currentPersonId: '',
            isShowTeacherDetailInfoDialogOpen: false,
        };
    },
    mounted() {
        this.getProjectTeacherCourseData();
    },
    methods: {
        getProjectTeacherCourseData() {
            projectApi.project.teacherCourse.getProjectTeacherCourseData(this.projectId).then(res => {
                this.projectTeacherCourseData = res.data;
            });
        },

        btnShowCourseDetailInfo_Click(courseId) {
            this.currentCourseId = courseId;
            this.isShowCourseDetailInfoDialogOpen = true;
        },
        btnShowTrainerDetailInfo_Click(personId) {
            this.currentPersonId = personId;
            this.isShowTeacherDetailInfoDialogOpen = true;
        }
    }
}
</script>

<style scoped>

</style>